// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { colors, layout, shadows } from '@/theme';
import MapComponent from '@/components/maps/map1';
import Fetch from '@/utils/Fetch';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'



function JobMap() {

  const [validJobs, setValidJobs] = useState<any[]>([]);
  const [markers, setMarkers] = useState<any[]>([]);
  const [centerPosition, setCenterPosition] = useState<any>();

  const { data: jobsData } = useQuery(
    ['jobMap'],
    () => Fetch.post({ url: '/job/getjobs', params: { PageSize: 99 } })
  );

  useEffect(() => {
    if (!jobsData?.Results) return;

    const jobsWithLocation = jobsData.Results.filter((job: any) => job.Location);
    let temp = [];
    for (let job of jobsWithLocation) {
      let location = job.Location;
      if (location.Longitude && location.Longitude) {
        temp.push({ ID: location.ID, JobID: job.ID, Description: location.LocationDisplay, Longitude: location.Longitude, Latitude: location.Latitude });
      }
    }

    const markerResult = [];
    const map = new Map();
    for (const item of temp) {
      if (!map.has((item as any).ID)) {
        map.set((item as any).ID, true);
        markerResult.push({ ID: (item as any).ID, JobID: (item as any).JobID, Description: (item as any).Description, Longitude: (item as any).Longitude, Latitude: (item as any).Latitude });
      }
    }

    setValidJobs(jobsWithLocation.filter((job: any) => markerResult.some((x: any) => x.JobID == job.ID)));
    if (markerResult.length > 0) {
      setCenterPosition([(markerResult[0] as any).Latitude, (markerResult[0] as any).Longitude]);
    }
    setMarkers(markerResult);
  }, [jobsData]);

  return (
    <div className="manage-container">
      <div className="split">
        <div className="job-container">
          {validJobs && validJobs.map(function (job: any, index: any) {
            return (
              <div key={index} className="job-card">
                <div className="job-number">
                  {job.JobCardNumber}
                </div>
                <div className="job-location">
                  {job.Location.LocationDisplay}
                </div>
              </div>
            );
          })}
        </div>
        <div className="job-map-container">
          <MapComponent centerPosition={centerPosition} markers={markers} />
        </div>
      </div>
      <style jsx>{`
        .job-container {
          display: flex;
          flex-direction: column;
          width: calc(25% - 1rem);
        }
        .job-card {
          background-color: ${colors.white};
          border-radius: ${layout.cardRadius};
          box-shadow: ${shadows.card};
          box-sizing: border-box;
          color: ${colors.darkSecondary};
          cursor: pointer;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          height: 13rem;
          margin-left: 1rem;
          margin-bottom: 1rem;
          opacity: 1;
          padding: 1rem;
          position: relative;
          transition: opacity 0.3s ease-in-out;
          width: 100%;
        }
        .job-map-container {
          background-color: ${colors.white};
          border-radius: ${layout.cardRadius};
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          height: 100%;
          margin-left: 1.5rem;
          padding: 1.5rem;
          width: calc(75% - 1rem);
        }
        .column {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }        
        .row {
          display: flex;
          justify-content: space-between;
        }
        .cancel-link {
          color: ${colors.bluePrimary};
          cursor: pointer;
          font-size: 0.875rem;
        }
      `}</style>
    </div>
  );
}

export default JobMap;

export const Route = createFileRoute('/_authenticated/job/job-map')({ component: JobMap })
